import { useState } from 'react';

interface Options {}

interface Returned {
    expanded: boolean;
    setExpandedHandler: (event: any) => void;
}

export function useRouteGroup(options: Options): Returned {
    const {} = options;

    const [expanded, setExpanded] = useState<boolean>(true);

    const setExpandedHandler = (event: any) => {
        event?.stopPropagation();
        setExpanded((prev) => !prev);
    };

    return {
        expanded,
        setExpandedHandler,
    };
}
